import { apiRequest } from "../services/apiRequest";

export const MerchantsApi = {
  listApprovedMerchants: async (data) => {
    const params = new URLSearchParams();

    if (data?.vendor_name) params.append("vendor_name", data.vendor_name);
    if (data?.business) params.append("business_name", data.business);
    if (data?.status) params.append("status", data.status);
    if (data?.page) params.append("page", data.page);
    if (data?.country) params.append("country", String(data.country).toUpperCase());
    if (data?.industry) params.append("industry", data.industry);
    if (data?.has_store) params.append("has_store", data.has_store);
    if (data?.ordering) params.append("ordering", data.ordering);
    if (data?.order_by) params.append("order_by", data.order_by);

    const queryString = params.toString();
    const url = queryString ? `/api/business/?${queryString}` : "/api/business/";

    return await apiRequest("get", url);
  },

  /** Same filters as listApprovedMerchants; adds export=csv for blob download */
  exportApprovedMerchantsCsv: async (data = {}) => {
    const params = new URLSearchParams();
    params.append("export", "csv");
    if (data?.vendor_name) params.append("vendor_name", data.vendor_name);
    if (data?.business) params.append("business_name", data.business);
    if (data?.status) params.append("status", data.status);
    if (data?.country)
      params.append("country", String(data.country).toUpperCase());
    if (data?.industry) params.append("industry", data.industry);
    if (data?.has_store) params.append("has_store", data.has_store);
    if (data?.ordering) params.append("ordering", data.ordering);

    const queryString = params.toString();
    const url = `/api/business/?${queryString}`;

    return await apiRequest("get", url, undefined, {
      skipCache: true,
      responseType: "blob",
    });
  },
  updateBusiness:async (data, businessId) => await apiRequest(`patch`,`/api/business/${businessId}/`,data ),
  deleteBusiness: async ( businessId) => await apiRequest(`delete`,`/api/business/${businessId}/`, )

};
